import { GenericService } from '@/services/api/generic.service';
import { EncounterRequestOriginalAnswer } from '@/custom/menicon/models';

export class ExpertModeRequestOriginalAnswersService extends GenericService<EncounterRequestOriginalAnswer> {
  constructor(requestId: string) {
    super(`menicon/v1/expert-mode/encounter-requested-advices/${requestId}/original-answers`);
  }
}
